<template>
  <div>
    <Table />
    <RelatedPersonTable />
  </div>
</template>

<script>
import RelatedPersonTable from './components/tables/RelatedPersonTable.vue'
import Table from './components/tables/Table.vue'

export default {
  components: {
    Table,
    RelatedPersonTable,
  },
}
</script>
